import { Provider } from "react-redux";
import "./App.css";
import Main from "./component/Layout/Main";
import store from "./Redux/store";
import "./styles/style.css";

function App() {
  return (
    <Provider store={store}>
      <Main></Main>
    </Provider>
  );
}

export default App;
